<template>
  <div>
    <div class="row">
      <div class="col-12">
        <chart-filters hide-dates></chart-filters>
      </div>
      <div class="col-12" v-if="filters.prisonGroupId && filters.before && filters.after">
        <b-tabs content-class="mt-3">
          <template #tabs-end>
            <prison-tab-name></prison-tab-name>
          </template>

          <b-tab title="Age Breakdown" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <visitor-users-age :filters="filters" :additional-user="false"></visitor-users-age>
              </div>
              <div class="col-6" v-if="compareMode">
                <visitor-users-age :filters="compareFilters" :additional-user="false"></visitor-users-age>
              </div>
            </div>
          </b-tab>
          <b-tab title="Countries" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <visitor-users-countries :filters="filters"></visitor-users-countries>
              </div>
              <div class="col-6" v-if="compareMode">
                <visitor-users-countries :filters="compareFilters"></visitor-users-countries>
              </div>
            </div>
          </b-tab>
          <b-tab title="Device Type" lazy>
            <div class="row">
              <div :class="compareMode ? 'col-6' : 'col-12'">
                <visitor-users-device-type :filters="filters"></visitor-users-device-type>
              </div>
              <div class="col-6" v-if="compareMode">
                <visitor-users-device-type :filters="compareFilters"></visitor-users-device-type>
              </div>
            </div>
          </b-tab>
          <!--          <b-tab title="Postcodes" lazy>-->
          <!--            <visitor-users-postcodes></visitor-users-postcodes>-->
          <!--          </b-tab>-->
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import ChartFilters from '../components/chartFilters/ChartFilters.vue';
  import VisitorUsersAge from '../components/charts/visitorUsers/VisitorUsersAge.vue';
  import VisitorUsersCountries from '../components/tables/visitorUserCountries/VisitorUsersCountriesTable.vue';
  // import VisitorUsersPostcodes from '../components/charts/visitorUsers/VisitorUsersPostcodes.vue';
  import VisitorUsersDeviceType from '../components/charts/visitorUsers/VisitorUsersDeviceType.vue';
  import PrisonTabName from '../components/other/PrisonTabName.vue';

  export default {
    components: {
      ChartFilters,
      VisitorUsersAge,
      VisitorUsersCountries,
      VisitorUsersDeviceType,
      PrisonTabName,
      // VisitorUsersPostcodes,
    },
    computed: {
      ...mapState({
        filters: state => state.stats.filters,
        compareFilters: state => state.stats.compareFilters,
        compareMode: state => state.stats.compareMode,
      }),
    },
  }
</script>

<style>

</style>
